import {AthleteLogoParams} from "../../common/athlete/athlete-logo-params";
import {MemberViewModel} from "./member-view-model";

export class MemberLogoParams extends AthleteLogoParams {
  isNational: Boolean;

  constructor(params: MemberLogoParams, entity: MemberViewModel) {
    super({...params, resourceName: 'Athletes'}, entity);

    this.id = entity.athleteId;
    this.fallbackResourceId = this.isNational ? entity.athleteId : 'default';
  }
}
